export const environment = {

	// Local
	// API_END_URL: "http://localhost:3001/api/v1/",

	// Production
	API_END_URL: "https://api.businessclassforless.com/api/v1/",

};
